import React, { Fragment, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Typography, Box } from '@material-ui/core';

function PreferencesInfo() {
  const prefs = useSelector(state => state.user.prefs);
  const analysisProfiles = useSelector(
    state => state.lookups.uiData.analysisProfiles
  );
  const [areaUnit, setAreaUnit] = useState('Hectares');
  const [analysisProfile, setAnalysisProfile] = useState('Residential');
  const units = {
    ac: 'Acres',
    ha: 'Hectares',
    m2: 'm²',
    sqft: 'sqft'
  };

  useEffect(() => {
    // if (prefs.defaultAnalysisProfileId) {
    //   analysisProfiles.forEach(profile => {
    //     if (profile.id === prefs.defaultAnalysisProfileId) {
    //       setAnalysisProfile(profile.name);
    //     }
    //   });
    // }

    if (prefs.defaultAreaUnit) {
      const newAreaUnit = prefs.defaultAreaUnit;

      setAreaUnit(units[newAreaUnit]);
    }
  }, [prefs]);

  return (
    <Fragment>
      <Typography component="div" color="textPrimary" variant="body2">
        {/* <Box>Analysis Profile = {analysisProfile}</Box> */}
        <Box>Default Units = {areaUnit}</Box>
      </Typography>
    </Fragment>
  );
}

export default PreferencesInfo;
